'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../../../icon/jsx/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // React component based on pp-vx design
// https://github.paypal.com/pages/PayPal-UI-R/VX/#switch


function Switch(props) {
  var className = props.className,
      ctrlIcon = props.ctrlIcon,
      error = props.error,
      helper = props.helper,
      icon = props.icon,
      id = props.id,
      isValid = props.isValid,
      label = props.label,
      name = props.name,
      value = props.value,
      rest = _objectWithoutProperties(props, ['className', 'ctrlIcon', 'error', 'helper', 'icon', 'id', 'isValid', 'label', 'name', 'value']);

  var baseClass = 'ppvx_switch';

  var wrapperClassNames = (0, _classnames2.default)(className, baseClass, {
    'ppvx_field--error': !isValid
  });

  return _react2.default.createElement(
    'div',
    { className: wrapperClassNames },
    label && _react2.default.createElement(
      'label',
      { htmlFor: id, className: baseClass + '__label' },
      label.text,
      icon && _react2.default.createElement(_Icon2.default, {
        className: baseClass + '__icon--right',
        name: icon.name,
        size: 'xs',
        title: icon.title
      })
    ),
    ctrlIcon && _react2.default.createElement(_Icon2.default, {
      className: baseClass + '__icon--left',
      name: ctrlIcon.name,
      size: 'xs',
      title: ctrlIcon.title
    }),
    _react2.default.createElement('input', _extends({
      type: 'checkbox',
      className: baseClass + '__control',
      id: id,
      name: name,
      role: 'switch',
      checked: value,
      'aria-checked': value,
      'aria-labelledby': 'l-switch-toggle'
    }, rest)),
    _react2.default.createElement(
      'label',
      { className: baseClass + '__state', htmlFor: id },
      _react2.default.createElement(
        'span',
        { className: baseClass + '__state--on' },
        'On'
      ),
      _react2.default.createElement(
        'span',
        { className: baseClass + '__state--off' },
        'Off'
      )
    ),
    !isValid && error ? _react2.default.createElement(
      'div',
      { className: baseClass + '__error-text' },
      error.text
    ) : helper && _react2.default.createElement(
      'div',
      { className: baseClass + '__helper-text' },
      helper.text
    )
  );
}

Switch.propTypes = {
  className: _propTypes2.default.string,
  ctrlIcon: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }),
  error: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  helper: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  icon: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }),
  id: _propTypes2.default.string.isRequired,
  isValid: _propTypes2.default.bool,
  label: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.bool
};

Switch.defaultProps = {
  className: '',
  ctrlIcon: {
    name: 'ppvx_icon-recurring',
    title: 'Recurring'
  },
  error: {
    text: 'This option is not valid when you have selected...' // overrides helper text when isValid is false
  },
  helper: {
    text: 'Get the latest news' // helper text that appears below the input
  },
  icon: {
    name: 'ppvx_icon-calendar',
    title: ''
  },
  isValid: true, // must be false for error message to show
  label: {
    text: 'Would you like to subscribe to our newsletter?'
  },
  value: undefined
};

exports.default = Switch;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/forms/switch/jsx/Switch.js
// module id = 1066
// module chunks = 4